export default {
  widgets: {
    problemCasesListTable: {
      headers: ['Клиент', 'Статус', 'Ответственное лицо', 'Дата', 'Комментарии'],
      noComments: 'Нет комментариев',
    },
  },
};
